function repositoryParts(repository: string): [string, string] {
  const [owner, name] = repository.split("/");
  if (!owner || !name) throw new Error("A GitHub repository must include its owner and name.");
  return [owner, name];
}

export function liveReviewPath(repository: string, pullNumber: number): string {
  const [owner, name] = repositoryParts(repository);
  return `/live/${encodeURIComponent(owner)}/${encodeURIComponent(name)}/${pullNumber}`;
}

export function guideAuthoringPath(repository: string, pullNumber: number): string {
  const [owner, name] = repositoryParts(repository);
  return `/author/${encodeURIComponent(owner)}/${encodeURIComponent(name)}/${pullNumber}`;
}

/**
 * The review page with its terraform sheet open.
 *
 * Terraform used to be its own route. It is a sheet over the review page now,
 * so a link to it is a link to the review page that says to open the sheet —
 * which means following one lands on the diff with the panel over it rather
 * than on a page with no code behind it.
 */
export function terraformPanelPath(repository: string, pullNumber: number): string {
  return `${liveReviewPath(repository, pullNumber)}?terraform=1`;
}
